'use client';

import { useRef, useState } from 'react';

export default function ContactSection() {
  const formRef = useRef<HTMLFormElement | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  const sendEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formRef.current || isSubmitting) return;

    try {
      setIsSubmitting(true);
      setIsSuccess(false);
      setIsError(false);

      const formData = new FormData(formRef.current);

      const payload = {
        name: String(formData.get('name') || ''),
        email: String(formData.get('email') || ''),
        phone: String(formData.get('phone') || ''),
        message: String(formData.get('message') || ''),
      };

      const res = await fetch('/send-mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok || !data.ok) {
        throw new Error(data.error || 'Send error');
      }

      formRef.current.reset();
      setIsSuccess(true);
    } catch (error) {
      console.error('Send form error:', error);
      setIsError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section data-component-id="src/components/ui/ContactSection.tsx:54:4" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="54" data-component-end-line="137" data-component-file="ContactSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20bg-%5B%23303030%5D%20py-16%20sm%3Apy-20%20lg%3Apy-24%22%7D" className="w-full bg-[#303030] py-16 sm:py-20 lg:py-24">
      <div data-component-id="src/components/ui/ContactSection.tsx:55:6" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="55" data-component-end-line="136" data-component-file="ContactSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mx-auto%20max-w-%5B1440px%5D%20px-4%20sm%3Apx-6%20lg%3Apx-16%22%7D" className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-16">
        <div data-component-id="src/components/ui/ContactSection.tsx:56:8" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="56" data-component-end-line="135" data-component-file="ContactSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20items-center%20gap-12%20lg%3Agrid-cols-2%22%7D" className="grid items-center gap-12 lg:grid-cols-2">
          <div data-component-id="src/components/ui/ContactSection.tsx:57:10" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="57" data-component-end-line="80" data-component-file="ContactSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-%5B%23b3b3b3%5D%22%7D" className="text-[#b3b3b3]">
            <p data-component-id="src/components/ui/ContactSection.tsx:58:12" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="58" data-component-end-line="58" data-component-file="ContactSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B20px%5D%20sm%3Atext-%5B24px%5D%22%2C%22textContent%22%3A%22Get%20in%20touch%22%7D" className="text-[20px] sm:text-[24px]">Get in touch</p>

            <h2 data-component-id="src/components/ui/ContactSection.tsx:60:12" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="60" data-component-end-line="62" data-component-file="ContactSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22mt-4%20text-%5B40px%5D%20sm%3Atext-%5B50px%5D%20font-bold%20leading-%5B1.1%5D%22%2C%22textContent%22%3A%22Let%E2%80%99s%20discuss%20your%20project%22%7D" className="mt-4 text-[40px] sm:text-[50px] font-bold leading-[1.1]">
              Let’s discuss your project
            </h2>

            <p data-component-id="src/components/ui/ContactSection.tsx:64:12" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="64" data-component-end-line="67" data-component-file="ContactSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mt-6%20max-w-%5B500px%5D%20text-%5B16px%5D%20sm%3Atext-%5B18px%5D%20leading-%5B1.6%5D%22%2C%22textContent%22%3A%22Tell%20us%20about%20your%20needs%2C%20and%20our%20team%20will%20prepare%20a%20tailored%20solution%20based%20on%20your%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20project%20requirements.%22%7D" className="mt-6 max-w-[500px] text-[16px] sm:text-[18px] leading-[1.6]">
              Tell us about your needs, and our team will prepare a tailored solution based on your
              project requirements.
            </p>

            <div data-component-id="src/components/ui/ContactSection.tsx:69:12" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="69" data-component-end-line="79" data-component-file="ContactSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-8%20grid%20gap-4%20sm%3Agrid-cols-2%22%7D" className="mt-8 grid gap-4 sm:grid-cols-2">
              <div data-component-id="src/components/ui/ContactSection.tsx:70:14" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="70" data-component-end-line="73" data-component-file="ContactSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22rounded-xl%20border%20border-white%2F10%20p-4%22%7D" className="rounded-xl border border-white/10 p-4">
                <p data-component-id="src/components/ui/ContactSection.tsx:71:16" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="71" data-component-end-line="71" data-component-file="ContactSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-white%2F50%22%2C%22textContent%22%3A%22Approach%22%7D" className="text-sm text-white/50">Approach</p>
                <p data-component-id="src/components/ui/ContactSection.tsx:72:16" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="72" data-component-end-line="72" data-component-file="ContactSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mt-2%20text-white%22%2C%22textContent%22%3A%22Custom%20solution%20for%20each%20project%22%7D" className="mt-2 text-white">Custom solution for each project</p>
              </div>

              <div data-component-id="src/components/ui/ContactSection.tsx:75:14" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="75" data-component-end-line="78" data-component-file="ContactSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22rounded-xl%20border%20border-white%2F10%20p-4%22%7D" className="rounded-xl border border-white/10 p-4">
                <p data-component-id="src/components/ui/ContactSection.tsx:76:16" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="76" data-component-end-line="76" data-component-file="ContactSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-white%2F50%22%2C%22textContent%22%3A%22Focus%22%7D" className="text-sm text-white/50">Focus</p>
                <p data-component-id="src/components/ui/ContactSection.tsx:77:16" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="77" data-component-end-line="77" data-component-file="ContactSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mt-2%20text-white%22%2C%22textContent%22%3A%22Design%20%2B%20functionality%22%7D" className="mt-2 text-white">Design + functionality</p>
              </div>
            </div>
          </div>

          <div data-component-id="src/components/ui/ContactSection.tsx:82:10" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="82" data-component-end-line="134" data-component-file="ContactSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
            <div data-component-id="src/components/ui/ContactSection.tsx:83:12" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="83" data-component-end-line="133" data-component-file="ContactSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22rounded-2xl%20border%20border-white%2F10%20bg-white%2F5%20p-6%20backdrop-blur%20sm%3Ap-8%22%7D" className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur sm:p-8">
              <h3 data-component-id="src/components/ui/ContactSection.tsx:84:14" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="84" data-component-end-line="84" data-component-file="ContactSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B22px%5D%20font-bold%20text-white%22%2C%22textContent%22%3A%22Contact%20us%22%7D" className="text-[22px] font-bold text-white">Contact us</h3>

              <form data-component-id="src/components/ui/ContactSection.tsx:86:14" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="86" data-component-end-line="132" data-component-file="ContactSection.tsx" data-component-name="form" data-component-content="%7B%22elementName%22%3A%22form%22%2C%22className%22%3A%22mt-6%20space-y-4%22%7D" ref={formRef} onSubmit={sendEmail} className="mt-6 space-y-4">
                <input data-component-id="src/components/ui/ContactSection.tsx:87:16" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="87" data-component-end-line="93" data-component-file="ContactSection.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22name%22%3A%22name%22%2C%22className%22%3A%22w-full%20rounded-lg%20border%20border-white%2F10%20bg-white%20px-4%20py-3%20text-black%20outline-none%20focus%3Aborder-%5B%239000ff%5D%22%7D"
                  type="text"
                  name="name"
                  placeholder="Your name"
                  required
                  className="w-full rounded-lg border border-white/10 bg-white px-4 py-3 text-black outline-none focus:border-[#9000ff]"
                />

                <input data-component-id="src/components/ui/ContactSection.tsx:95:16" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="95" data-component-end-line="101" data-component-file="ContactSection.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22email%22%2C%22name%22%3A%22email%22%2C%22className%22%3A%22w-full%20rounded-lg%20border%20border-white%2F10%20bg-white%20px-4%20py-3%20text-black%20outline-none%20focus%3Aborder-%5B%239000ff%5D%22%7D"
                  type="email"
                  name="email"
                  placeholder="Email"
                  required
                  className="w-full rounded-lg border border-white/10 bg-white px-4 py-3 text-black outline-none focus:border-[#9000ff]"
                />

                <input data-component-id="src/components/ui/ContactSection.tsx:103:16" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="103" data-component-end-line="109" data-component-file="ContactSection.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22tel%22%2C%22name%22%3A%22phone%22%2C%22className%22%3A%22w-full%20rounded-lg%20border%20border-white%2F10%20bg-white%20px-4%20py-3%20text-black%20outline-none%20focus%3Aborder-%5B%239000ff%5D%22%7D"
                  type="tel"
                  name="phone"
                  placeholder="Phone number"
                  required
                  className="w-full rounded-lg border border-white/10 bg-white px-4 py-3 text-black outline-none focus:border-[#9000ff]"
                />

                <textarea data-component-id="src/components/ui/ContactSection.tsx:111:16" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="111" data-component-end-line="117" data-component-file="ContactSection.tsx" data-component-name="textarea" data-component-content="%7B%22elementName%22%3A%22textarea%22%2C%22name%22%3A%22message%22%2C%22className%22%3A%22w-full%20resize-none%20rounded-lg%20border%20border-white%2F10%20bg-white%20px-4%20py-3%20text-black%20outline-none%20focus%3Aborder-%5B%239000ff%5D%22%7D"
                  name="message"
                  placeholder="Your message"
                  rows={4}
                  required
                  className="w-full resize-none rounded-lg border border-white/10 bg-white px-4 py-3 text-black outline-none focus:border-[#9000ff]"
                />

                <button data-component-id="src/components/ui/ContactSection.tsx:119:16" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="119" data-component-end-line="125" data-component-file="ContactSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22submit%22%2C%22className%22%3A%22w-full%20rounded-full%20bg-%5B%239000ff%5D%20py-3%20text-%5B16px%5D%20font-bold%20text-white%20transition%20hover%3Ascale-%5B1.02%5D%20disabled%3Aopacity-70%22%7D"
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full rounded-full bg-[#9000ff] py-3 text-[16px] font-bold text-white transition hover:scale-[1.02] disabled:opacity-70"
                >
                  {isSubmitting ? 'Sending...' : 'Send request'}
                </button>

                {isSuccess && <p data-component-id="src/components/ui/ContactSection.tsx:127:30" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="127" data-component-end-line="127" data-component-file="ContactSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-green-400%22%2C%22textContent%22%3A%22Message%20sent%20successfully%22%7D" className="text-sm text-green-400">Message sent successfully</p>}

                {isError && (
                  <p data-component-id="src/components/ui/ContactSection.tsx:130:18" data-component-path="src/components/ui/ContactSection.tsx" data-component-line="130" data-component-end-line="130" data-component-file="ContactSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-red-400%22%2C%22textContent%22%3A%22Something%20went%20wrong.%20Please%20try%20again.%22%7D" className="text-sm text-red-400">Something went wrong. Please try again.</p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// 'use client';

// import { useRef, useState } from 'react';
// import emailjs from '@emailjs/browser';

// export default function ContactSection() {
//   const formRef = useRef<HTMLFormElement | null>(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isSuccess, setIsSuccess] = useState(false);

//   const sendEmail = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!formRef.current || isSubmitting) return;

//     try {
//       setIsSubmitting(true);
//       setIsSuccess(false);

//       await emailjs.sendForm(
//         process.env.NEXT_PUBLIC_EMAILJS_SERVICE_ID!,
//         process.env.NEXT_PUBLIC_EMAILJS_TEMPLATE_ID!,
//         formRef.current,
//         process.env.NEXT_PUBLIC_EMAILJS_PUBLIC_KEY!
//       );

//       formRef.current.reset();
//       setIsSuccess(true);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <section className="w-full bg-[#303030] py-16 sm:py-20 lg:py-24">
//       <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-16">
//         <div className="grid items-center gap-12 lg:grid-cols-2">
//           {/* LEFT */}
//           <div className="text-[#b3b3b3]">
//             <p className="text-[20px] sm:text-[24px]">Get in touch</p>

//             <h2 className="mt-4 text-[40px] sm:text-[50px] font-bold leading-[1.1]">
//               Let’s discuss your project
//             </h2>

//             <p className="mt-6 max-w-[500px] text-[16px] sm:text-[18px] leading-[1.6]">
//               Tell us about your needs, and our team will prepare a tailored solution based on your
//               project requirements.
//             </p>

//             {/* доп блоки */}
//             <div className="mt-8 grid gap-4 sm:grid-cols-2">
//               <div className="rounded-xl border border-white/10 p-4">
//                 <p className="text-sm text-white/50">Approach</p>
//                 <p className="mt-2 text-white">Custom solution for each project</p>
//               </div>

//               <div className="rounded-xl border border-white/10 p-4">
//                 <p className="text-sm text-white/50">Focus</p>
//                 <p className="mt-2 text-white">Design + functionality</p>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT — FORM */}
//           <div className="relative">
//             <div className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur sm:p-8">
//               <h3 className="text-[22px] font-bold text-white">Contact us</h3>

//               <form ref={formRef} onSubmit={sendEmail} className="mt-6 space-y-4">
//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="Your name"
//                   required
//                   className="w-full rounded-lg border border-white/10 bg-white px-4 py-3 text-black outline-none focus:border-[#9000ff]"
//                 />

//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="Email"
//                   required
//                   className="w-full rounded-lg border border-white/10 bg-white px-4 py-3 text-black outline-none focus:border-[#9000ff]"
//                 />

//                 <input
//                   type="tel"
//                   name="phone"
//                   placeholder="Phone number"
//                   required
//                   className="w-full rounded-lg border border-white/10 bg-white px-4 py-3 text-black outline-none focus:border-[#9000ff]"
//                 />

//                 <textarea
//                   name="message"
//                   placeholder="Your message"
//                   rows={4}
//                   required
//                   className="w-full resize-none rounded-lg border border-white/10 bg-white px-4 py-3 text-black outline-none focus:border-[#9000ff]"
//                 />

//                 {/* КНОПКА В ТВОЁМ СТИЛЕ */}
//                 <button
//                   type="submit"
//                   disabled={isSubmitting}
//                   className="
//                     w-full
//                     rounded-full bg-[#9000ff]
//                     py-3
//                     text-[16px] font-bold text-white
//                     transition hover:scale-[1.02]
//                     disabled:opacity-70
//                   "
//                 >
//                   {isSubmitting ? 'Sending...' : 'Send request'}
//                 </button>

//                 {isSuccess && <p className="text-sm text-green-400">Message sent successfully</p>}
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
